import { icon } from '../lib/icons';
import type { RouteHandler } from '../lib/router';
import { renderPageShell } from '../lib/page-shell';

/**
 * "Choose Your Game" — the game library (renamed/restructured from the old
 * duel-only "Choose Your Duel" menu, owner brief 2026-08-18). This screen
 * picks a GAME; each game then has its own mode menu
 * (`stop-the-clock-menu.ts` / `stack-tower-menu.ts`) reached from here.
 * Deliberately game-first, not mode-first: the old menu mixed Stack Tower's
 * four modes into the same flat grid as the duel's modes, which read as one
 * game with a lot of options rather than two separate games.
 */
export const renderPlayMenu: RouteHandler = (container, navigate) => {
  renderPageShell(container, navigate, 'play', {
    title: 'CHOOSE YOUR GAME',
    subtitle: 'Pick a game, then pick how you want to play it.',
    body: `
      <div class="game-library">
        <button class="game-card" type="button" data-nav="play/stop-the-clock">
          <span class="game-card__icon">${icon('clock')}</span>
          <span class="game-card__body">
            <strong>Stop the Clock</strong>
            <small>No reflexes, no aim, just your internal clock. Knockout, ranked, local and custom matches, practice, and the 10 Second Challenge.</small>
          </span>
          ${icon('arrow')}
        </button>
        <button class="game-card" type="button" data-nav="play/stack-tower">
          <span class="game-card__icon">${icon('tower')}</span>
          <span class="game-card__body">
            <strong>Stack Tower</strong>
            <small>Tap to place. Only the overlap survives. Solo, 60 Second, head-to-head and ranked.</small>
          </span>
          ${icon('arrow')}
        </button>
      </div>
    `,
  });
};
